import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { PreventifState, state as preventifState } from './state';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import equipementInterventionsState, { EquipementInterventionsState } from './modules/state';
import equipementInterventionModule from './modules';

export interface PreventifModuleState extends PreventifState {
    equipementInterventionsState: EquipementInterventionsState;
}

const state: PreventifModuleState = {
    ...preventifState,
    equipementInterventionsState,
};

const module: Module<PreventifModuleState, RootState> = {
    modules: {
        equipementInterventions: equipementInterventionModule,
    },
    state,
    mutations,
    getters,
    actions,
};

export default module;
export type { PreventifState };
